import React from 'react';
import { useUniversity } from '@/hooks/useUniversity';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Building } from 'lucide-react';

export default function UniversitySwitcher() {
  const {
    universities,
    activeUniversity,
    switchUniversity,
    hasMultipleUniversities,
    isSuperAdmin,
    isLoading
  } = useUniversity();

  if (isLoading) {
    return (
      <div className="neumorphic-inset rounded-xl p-3 animate-pulse">
        <div className="h-6 bg-gray-300 rounded"></div>
      </div>
    );
  }

  if (!hasMultipleUniversities && !isSuperAdmin) {
    if (!activeUniversity) return null;

    return (
      <div className="neumorphic-inset rounded-xl p-3">
        <div className="flex items-center gap-2">
          <Building className="w-4 h-4 text-gray-500" />
          <span className="text-sm font-medium text-gray-700">
            {activeUniversity.name}
          </span>
        </div>
      </div>
    );
  }

  const handleChange = async (value) => {
    try {
      if (value === 'all-universities') {
        await switchUniversity(null);
      } else {
        await switchUniversity(value);
      }
    } catch (error) {
      console.error('Failed to switch university:', error);
    }
  };

  return (
    <div className="neumorphic-inset rounded-xl p-2">
      <Select
        value={activeUniversity?.id || 'all-universities'}
        onValueChange={handleChange}
      >
        <SelectTrigger className="border-0 bg-transparent focus:ring-0 focus:ring-offset-0">
          <div className="flex items-center gap-2">
            <Building className="w-4 h-4 text-gray-500" />
            <SelectValue placeholder="Select University" />
          </div>
        </SelectTrigger>
        <SelectContent className="neumorphic rounded-xl">
          {isSuperAdmin && (
            <SelectItem value="all-universities" className="cursor-pointer">
              All Universities
            </SelectItem>
          )}
          {isSuperAdmin && universities.length === 0 ? (
            <SelectItem value="no-university" disabled>
              No universities available
            </SelectItem>
          ) : (
            universities.map((university) => (
              <SelectItem
                key={university.id}
                value={university.id}
                className="cursor-pointer"
              >
                {university.name}
              </SelectItem>
            ))
          )}
        </SelectContent>
      </Select>
    </div>
  );
}
